<template>
  <div id="basics-info">
    <MyLine/>
    <div id="box">
      <div id="title">基本资料</div>
      <div id="content">
        <div class="row">
          <p>申请人</p>
          <p>{{name}}</p>
        </div>
        <div class="row">
          <p>申请时间</p>
          <p>{{applyTime | formatDate}}</p>
        </div>
        <div class="row">
          <p>手机号码</p>
          <p>{{phone}}</p>
        </div>
        <div class="row">
          <p>取车时间</p>
          <p>{{getCarTime | formatDate}}</p>
        </div>
        <div class="row">
          <p>取/还车地址</p>
          <p>{{addr}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MyLine from '../widget/line'

  export default {
    name: "basicsInfo",
    props:{
      name:{type: String, default: '-----'},
      applyTime:{type: Number,},
      phone:{type: String, default: '-----------'},
      getCarTime:{type: Number,},
      addr:{type: String, default: '----------------------------'}
    },
    components:{
      MyLine,
    },
    filters:{
      formatDate(dateTime) {
        if ((''+dateTime).length === 10) {
          return new Date(dateTime*1000).Format('yyyy/MM/dd hh:mm')
        }
        return '----/--/-- --:--';
      }
    },
  }
</script>

<style scoped>
  #box{
    width: 92vw;
    margin: 0 auto;
    background: white;
    border-radius: 1.333vw;
    box-sizing: border-box;
    padding: 2.667vw 3.2vw;
  }
  #title{
    font-size: 3.2vw;
    color: #909399;
    padding-bottom: 2vw;
    border-bottom: 1px solid #edeff2;
  }
  #content{
    margin-top: 4vw;
  }
  .row{
    min-height: 6vw;
    display: flex;
    /*align-items: center;*/
  }
  .row>p:first-child{
    width: 20vw;
    font-size: 3.467vw;
    color: #909399;
  }
  .row>p:last-child{
    flex: 1;
    font-size: 3.467vw;
    color: #303133;
  }
</style>
